export const getInitialValues = (settings, savedClassificationValues = {}) => {
    let values = {
        Classification: [],
    };
    // Override any existing data with user-input data that has been stored
    if (Object.keys(savedClassificationValues).length > 0) {
        values = {
            ...values,
            ...savedClassificationValues,
        };
    }
    return values;
};
